import { lazy } from 'react';

import AppLayout from '@/layout/appLayout';
import Loadable from '@/components/Loadable';

// 페이지 단위로 코드 스플리팅해 첫 로드 JS 를 줄인다.
const Main = Loadable(lazy(() => import('@/pages/section/main')));
const About = Loadable(lazy(() => import('@/pages/section/about')));
const Portfolio = Loadable(lazy(() => import('@/pages/section/portfolio')));
const PortfolioDetail = Loadable(
    lazy(() => import('@/pages/section/portfolioDetail'))
);
const Career = Loadable(lazy(() => import('@/pages/section/career')));
const Contact = Loadable(lazy(() => import('@/pages/section/contact')));

const AppRoutes = {
    path: '/',
    element: <AppLayout />,
    children: [
        { path: '/', element: <Main /> },
        { path: '/about', element: <About /> },
        { path: '/portfolio', element: <Portfolio /> },
        { path: '/portfolio/:id', element: <PortfolioDetail /> },
        { path: '/career', element: <Career /> },
        { path: '/contact', element: <Contact /> }
    ]
};

export default AppRoutes;
